import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  input,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';

export interface TableColumn {
  id: string;
  label: string;
  width?: string;
}

export type TableData = Record<string, unknown>;

export interface ActionsTemplateContext {
  $implicit: TableData;
}

@Component({
  selector: 'app-plain-table',
  standalone: true,
  imports: [NgTemplateOutlet, SkeletonComponent],
  templateUrl: './plain-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlainTableComponent {
  columns = input.required<TableColumn[]>();
  data = input.required<TableData[]>();
  isLoading = input(false);

  @ContentChild('actions')
  actionsTemplate?: TemplateRef<ActionsTemplateContext>;
}
